"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTransferLinesClientComplete = void 0;
const helpers_1 = require("../../helpers");
const checkTransferLineComplete_1 = require("./checkTransferLineComplete");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
/*
  This function checks if all transfer lines in an order are complete. If any line is incomplete, it updates the status of that line to 'WAITING_FOR_CLIENT_TRANSFER_INFO'.
  It returns true if all lines are complete, otherwise false.
  Cancelled lines are ignored.

  @param {SupabaseClient} supabase - The Supabase client instance.
  @param {OrderLine[]} transfer_lines - An array of transfer lines to check.
  @returns {Promise<boolean>} - Returns true if all lines are complete, otherwise false.
*/
const checkTransferLinesClientComplete = async (supabase, transfer_lines) => {
    const incomplete_lines = [];
    for (const line of transfer_lines) {
        if (!line.versions)
            throw new Error("Order line does not have versions");
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            continue;
        if (helpers_1.CANCELLED_ORDER_STATUSES.includes(latest_version.status))
            continue;
        const config = latest_version?.config;
        const transfer_line_complete = await (0, checkTransferLineComplete_1.checkTransferLineComplete)(config);
        if (!transfer_line_complete) {
            incomplete_lines.push(latest_version);
        }
    }
    for (const line of incomplete_lines) {
        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
            ...line,
            status: helpers_1.OrderLineStatus.WAITING_FOR_CLIENT_TRANSFER_INFO,
        });
    }
    return incomplete_lines.length === 0;
};
exports.checkTransferLinesClientComplete = checkTransferLinesClientComplete;
